module.exports = __webpack_public_path__ + "static/media/ic_show_purchases.f0fdb48b.svg";